// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3OOTC","notes":"Notes_notes__2wl6b","note":"Notes_note__1IIsk","markdown":"Notes_markdown__2IYvN"};